import {
  buildLabelForDelivery,
  getColorForStatus,
  getDisplayNameForStatus
} from "./utils";
import { downloadBill } from "../02_Bills/api";
import React from "react";
import { usePOSATypesSelector } from "../../redux/actions/wheel";
import moment from "moment-timezone";
import { tt } from "../../utils/i18n/i18n";
import { type POSADeliveryWithBill } from "./api";
import KC_Table from "../../designsystem/KC_Table/KC_Table";

import { useAccountToDisplaySelector } from "../../redux/actions/user";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";

interface Props {
  aggregate: boolean;
  keyPrefix: string;
  posaDeliveries: POSADeliveryWithBill[] | undefined;
  introText?: string;
  showModal: (delivery: POSADeliveryWithBill) => void;
  hideStatus?: boolean;
  hideCTA: boolean;
  displayComments?: boolean;
  businessUserId: string;
}

export function POSADeliveriesTable(props: Props) {
  const allPOSATypes = usePOSATypesSelector();
  const { accountToDisplay } = useAccountToDisplaySelector();

  if (!props.posaDeliveries?.length) {
    return (
      <KC_UIText weight="reg" text={tt("none_feminine")} className="mt-2" />
    );
  }

  return (
    <>
      {!!props.introText && <p>{tt("posa_to_validate_explanation_text")}</p>}
      <KC_Table
        keyPrefix={"posa"}
        headers={
          <>
            {props.aggregate && <th>{tt("establishment")}</th>}
            <th>{tt("posa_order_date")}</th>
            <th>ID</th>
            <th>{tt("type")}</th>
            <th>{tt("quantity")}</th>
            {props.displayComments && <th>{tt("comments")}</th>}
            {!props.hideStatus && <th>{tt("status")}</th>}
            <th>{tt("bill")}</th>
          </>
        }
        children={
          <>
            {props.posaDeliveries?.map((delivery, deliveryIdx) => {
              return (
                <tr key={`posa-${props.keyPrefix}-${deliveryIdx}`}>
                  {props.aggregate && <td>{delivery.placeName}</td>}
                  <td>
                    {moment(delivery.ts, "X").format(tt("display_date_format"))}
                  </td>
                  <td>
                    {delivery.id.substring(
                      delivery.id.length - 8,
                      delivery.id.length
                    )}
                  </td>
                  <td>
                    <span
                      style={{
                        color: getDisplayNameForStatus(delivery)
                      }}
                    >
                      {buildLabelForDelivery(delivery, allPOSATypes)}
                    </span>
                  </td>
                  <td>{delivery.desiredQty}</td>
                  {props.displayComments && (
                    <td>{delivery.customerComments || tt("none_feminine")}</td>
                  )}
                  {!props.hideStatus && (
                    <td
                      className="font-weight-bold"
                      style={{
                        color: getColorForStatus(delivery)
                      }}
                    >
                      {getDisplayNameForStatus(delivery)}
                    </td>
                  )}
                  <td className="text-center">
                    {!(delivery.bill == null) && (
                      <i
                        className="fa fa-download"
                        onClick={() => {
                          if (delivery.bill == null) {
                            alert(tt("api_error"));
                            return;
                          }
                          void downloadBill({
                            billId: delivery.bill.id,
                            billNumber: delivery.bill.number,
                            monthAndYear: delivery.bill.monthAndYear,
                            token: accountToDisplay?.token
                          });
                        }}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </>
        }
      />
    </>
  );
}
